interface HandleOnBlurAttributes{
    value: any,
    validate: any,
    setClassName: (any) => void,
    defaultClassName: string,
    onBlurClassName: string,
}

const handleOnBlur = async (props:HandleOnBlurAttributes) => {
    const {
        value,
        setClassName,
        defaultClassName,
        onBlurClassName,
        validate,
    } = props

    if (value && validate(value)) {
        setClassName(onBlurClassName)
    } else {
        setClassName(defaultClassName)
    }
}

export default handleOnBlur